module.exports = __webpack_public_path__ + "static/img/study.2585f95b.png";